<div class="image-viewer-container" ngxViewer>
	<mat-grid-list cols="2" rowHeight="1:1" gutterSize="16px">
		<mat-grid-tile *ngFor="let item of source">
			<div class="__image">
				<img [src]="item.url" />
			</div>
		</mat-grid-tile>
	</mat-grid-list>
</div>
